/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from "axios";
import errorHint from "./errorHint";

const host = `${window.location.protocol}//${window.location.host}`;
const loginUrl = `/passport/login?ReturnUrl=${host}`;
const logoutUrl = `${host}/passport/logout`;

// console.log('process.env.NODE_ENV: ', process.env.NODE_ENV);
// npm start: development

// 创建axios实例，提供默认配置
const instance = axios.create({
  // baseURL: "http://vop.jd.local/api",
  baseURL: "/api",
  method: "post",
  withCredentials: true,
  // timeout: 1000 * 5,
});

/**
 * 请求拦截器
 */
instance.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // 这里可以加统一的参数，appid，token这类的
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.resolve(error);
  }
);

/**
 * 响应拦截器
 */
// instance.interceptors.response.use(
//   // 请求成功
//   // res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
//   res => {
//     const data = res.data || {};
//     if (!data.success) {
//       const result = data.result || {};
//       const errorMsg = result.resultMessage || '接口错误';
//       hintError.push(errorMsg);
//     }

//     return Promise.resolve(res);
//   },

//   // 请求失败
//   error => {
//     const { response } = error;
//     console.log('ajax response: ', response);

//     if (response) {
//       // 请求已发出，但是不在2xx的范围，一般会和后台确定一些错误码，处理错误
//       const errorMsg = response.data && response.data.message ? response.data.message : response.statusText;

//       errorMsg && hintError.push(errorMsg);
//       handleError(response.status, errorMsg);

//       return Promise.resolve(response);
//     } else {
//       // 请求都没发出去
//       // 处理断网的情况
//       if (!window.navigator.onLine) {
//           // 断网做啥
//       }
//       // Any status codes that falls outside the range of 2xx cause this function to trigger
//       // Do something with response error;
//       const errorData = {
//         success: false,
//         data: null,
//         msg: `HTTP ERROR: ${error.message || error}`
//       }
//       hintError.push(errorData.msg);
//       return Promise.resolve({ data: errorData });
//     }
//   }
// );

// 不需要检查登录权限的前端路由
const unauthorizedPaths = [
  /\/$/,
  /\/doc\/(api|guide|faq)$/,
  /\/notice$/,
  /\/notice\/.*/,
  /\/solve\/.*/,
  /\/paper$/,
  /\/apitest$/,
];

// 不需要跳转到登录页的接口
const unauthorizedApis = ["/api/queryLoginInfo"];

function checkNeedAuthorize(pathname) {
 
  for (let i = 0; i < unauthorizedPaths.length; i++) {
    if (unauthorizedPaths[i].test(pathname)) {
     
      return false;
    }
  }

  return true;
}

function handleError(errorCode, errorMessage, config) {
  const { location } = window;

  switch (errorCode) {
    case 401: // 未登录
      // if (
      //   checkNeedAuthorize(location.pathname) &&
      //   unauthorizedApis.indexOf(config.url) === -1
      // ) {
      //   location.href = loginUrl;
      // }
      break;
    default:
      console.log("http error: ", errorMessage);
      break;
  }
}

function hintError(config, errorMsg) {
  if (!config.handled && errorMsg) {
    errorHint.push(errorMsg);
  }
}

const request = (config, resolve) =>
  instance({ ...config })
    .then((response) => {
      const data = response.data || {};
      // resolve(data); // 应该resolve data, 外部调用时不用再解包
      // if (!data.result) {
      //   data.result = {};
      // }

      resolve(response);

      if (!data.success) {
        // const result = data.result || {};
        const errorMsg = data.resultMessage || "接口错误";
        hintError(config, errorMsg);
      }
    })
    .catch((error) => {
      const { response } = error;
      console.log("ajax response: ", response);

      if (response) {
        // 请求已发出，但是不在2xx的范围，一般会和后台确定一些错误码，处理错误
        const data = response.data || {};
        const errorMsg = data.message || response.statusText;

        hintError(config, errorMsg);
        handleError(response.status, errorMsg, config);

        resolve(response);
      } else {
        // 请求都没发出去
        // 处理断网的情况
        if (!window.navigator.onLine) {
          // 断网处理
        }
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        const data = {
          success: false,
          data: null,
          msg: `HTTP ERROR: ${error.message || error}`,
        };
        hintError(config, data.msg);
        resolve({ data });
      }
    });

const ajax = (config) => new Promise((resolve) => request(config, resolve));

export default ajax;

export { loginUrl, logoutUrl };
